<template>
  <section class="border border-gray-200 rounded p-3 space-y-2 bg-gray-50" v-if="check">
    <p class="font-medium text-primary">Handbook procedure check</p>
    <p class="text-sm text-gray-600">
      Checked against {{ check.CollectionName || "the tenant handbook collection" }}
      <span v-if="checkedAt"> on {{ checkedAt }}</span>.
    </p>
    <ul class="text-sm space-y-1" v-if="handbooks.length">
      <li v-for="handbook in handbooks" :key="handbook.ID">
        <router-link class="text-primary underline" :to="`/Database/Handbooks/${handbook.ID}`">{{ handbook.Name }}</router-link>
        <span v-if="handbook.Revision">, revision {{ handbook.Revision }}</span>
      </li>
    </ul>
    <p class="text-sm text-gray-600" v-else>No current handbook excerpt matched this course.</p>
    <ul class="text-sm text-red-700 list-disc pl-5" v-if="conflicts.length">
      <li v-for="(conflict, index) in conflicts" :key="index">
        {{ conflict.HandbookTitle }}<span v-if="conflict.Revision">, revision {{ conflict.Revision }}</span>: {{ conflict.Issue }}
      </li>
    </ul>
    <p class="text-sm text-green-800" v-else>No conflicts with the current handbook revisions.</p>
  </section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  check: { type: Object, default: null },
});

function asList(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
}

const handbooks = computed(() => asList(props.check?.Handbooks));
const conflicts = computed(() => asList(props.check?.Conflicts));
const checkedAt = computed(() => {
  const value = props.check?.CheckedAt;
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
});
</script>
